// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1-z6t","error":"Textarea_error__3bvEI","readonly":"Textarea_readonly__Zcg9C","disabled":"Textarea_disabled__2OV1m"};